import "./UpgradePlanPage.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import React, { useEffect, useState } from "react";

import ConfirmationImage from "../../_shared/assets/confirmation-image-ok-mark.svg";
import { useUserInfo } from "../actions/useUserInfo";
import { SubscriptionUpgrade } from "../components/Checkout/SubscriptionUpgrade";
import { clientEventTracker } from "../utils/clientTelemetry";

export const UpgradePlanPage: React.FC = () => {
  const { user } = useUserInfo();
  const [showSuccess, setShowSuccess] = useState<boolean>();

  useEffect(() => {
    if (user) {
      clientEventTracker.track("UpgradePlanPage viewed", user, {});
    }
  }, [user]);

  return (
    <div className="upgrade-plan-page">
      {showSuccess && (
        <Flex column gap="gap.medium" hAlign="center">
          <Text
            content="Your plan has been updated!"
            align="center"
            size="larger"
            weight="bold"
            color="brand"
          />

          <img src={ConfirmationImage} height={150} alt="Upgrade complete" />
        </Flex>
      )}

      {!showSuccess && <SubscriptionUpgrade onUpgraded={() => setShowSuccess(true)} />}
    </div>
  );
};
